//import { css, keyframes  } from '@emotion/core'
//import { variables, mq } from 'cssInJs'

import { css } from '@emotion/core'
import { mq, variables } from '../../../cssInJs'

export default {
    pageTiles : css({
         display: 'flex',
         justifyContent: 'flex-start',
         flexWrap: 'wrap',
         margin: '2rem -10px',
         overflow:'hidden'
    }),
    pageTile__tile : css(mq({
         flex: '0 0 100%',
         maxWidth: '100%',
         padding: '10px',
         zIndex: 1,
         '&:nth-of-type(even)' : {
               '.pageTile__bsyc__bg' : mq({
                    order: ['0',null,'2'],
               }),
               '.pageTile__bsyc__content__details' : mq({
                    order: '1'
               })
         }
    })),

    tile__content : css({
     //     display: 'flex',
     //     flexDirection: 'row',
     //     justifyContent: 'space-between',
     //     width: '100%',
     //     height: '100%',
     //     cursor: 'pointer',
     //     position: 'relative',
     //     flexWrap: 'wrap',
         '&:hover' : {
            textDecoration: 'none',
            '& .pageTile__bsyc__content__details' : {
               color: 'white',
               backgroundColor: variables.redColor,
               '& .pageTile__bsyc__title' : {
                    color: 'white'
               },
               '& .pageTile__bsyc__btn' : {
                    backgroundColor:'white',
                    color: variables.redColor
               }
               // '&.default' : css({
               //      backgroundColor: 'rgba(0,113,188,1)'
               // }),
               // '&.red' : css({
               //      backgroundColor: 'rgba(211,61,2,1)'
               // }),
               // '&.green' : css({
               //      backgroundColor: 'rgba(0, 146, 69,1)'
               // })
            },
            '& .pageTile__bsyc__bg2' : {
               //transform: scale(1.05)
               transform : 'scale(1.05)'
            }
         }
    }),

    tile__flip__wrapper : css({
          zIndex:'-1', 
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
          cursor: 'pointer',
          position: 'relative',
          flexWrap: 'wrap'
    }),

//     tile__bg : css(mq({
//          height: '0',
//          //paddingTop: '30%',
//          paddingTop: ['50%','35%','30%'],
//          backgroundPosition: '50%',
//          backgroundRepeat: 'no-repeat',
//          backgroundSize: 'cover',
//          flex: '1 1 300px'
//     })),

    tile__bg : css(mq({
          height: '0',
          paddingTop: ['50%','35%','30%'],
          //height: ['50%','35%','30%'],
          flex: '1 1 300px',
          overflow:'hidden',
          position:'relative'
    })),

    tile__bg2 : css(mq({
         height: '100%',
         backgroundPosition: '50%',
         backgroundRepeat: 'no-repeat',
         backgroundSize: 'cover',
         //overflow:'hidden',
         transition:'all .5s ease',
         position:'absolute',
         top:'0px',
         width:'100%'
    })),

    tile__details : css({
         overflow: 'hidden',
         flexGrow: '1',
         textAlign: 'center',
         width: '100%',
         bottom: '0',
         //backgroundColor: 'white',
         backgroundColor: variables.darkRecColor,
     //     '&.default' : css({
     //           backgroundColor: 'rgba(0, 113, 188,.5)'
     //     }),
     //     '&.red' : css({
     //           backgroundColor: 'rgba(211, 61, 2,.5)'
     //      }),
     //      '&.green' : css({
     //           backgroundColor: 'rgba(0, 146, 69,.5)'
     //      }),
         //backgroundColor : '#77cf22',
         flex: '1 1 300px',
         transition: 'all .2s ease-in-out',
         //color: variables.fontColor,
         color: 'white',
         position:'relative',
         '& .pageTile__bsyc__container' : mq({
            //position: 'absolute',
            position: ['static,',null,'absolute'],
            top: '50%',
            left:'50%',
            transform: ['none',null,'translate(-50%, -50%)'],
            width:['100%',null,'90%'],
            padding:['1rem',null,'0px'],
            '& .pageTile__bsyc__title' : {
                //fontFamily: 'proxima-soft, sans-serif',
                fontSize: '2rem',
                //textTransform: 'uppercase',
                //fontWeight: '700',
                lineHeight: '1',
                margin: '0',
                paddingTop: '.5rem',
                paddingBottom: '.5rem',
                //color:variables.redColor,
                color:'white',
                fontWeight: '600'
            },
            '& .pageTile__bsyc__desc' : {
                lineHeight: '1.3',
                fontSize: '.9rem',
                //color: '#3d3d3d',
                minHeight: '70px',
                color:'inherit'
             }
         })
    }),

    pageTile__bsyc__btn: css({
     backgroundColor: variables.redColor,
     color: 'white',
     fontSize: '0.8rem',
     fontWeight: '700',
     padding: '0.2rem 0.5rem',
     display: 'inline-block',
     marginTop: '1rem'
     //maxWidth: '168px'
   }),

   memberCounter : {
     display: 'flex'
   },

   memberCounterItem : mq({
     flex:'1 0 auto',
     paddingLeft: '0.2rem',
     paddingRight: '0.2rem',
     paddingTop:'0.5rem',
     paddingBottom:'0.5rem',
     fontWeight:'700',
     textAlign:'center',
     fontSize:'1.1rem',
     border: '1px solid white',
     margin:'auto',
     maxWidth:['280px', null, '306px'],
     'label' : {
          marginBottom: '0px'
     },
     // '.member__count' : {
     //      marginTop:'-7px'
     // }
   })

}